import { Button, Modal, Typography } from 'antd';
import React from 'react';

const { Text } = Typography;

interface ResetConfirmationModalProps {
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  loading: boolean;
  userFullName: string;
}

export const ResetConfirmationModal: React.FC<ResetConfirmationModalProps> = ({
  visible,
  onConfirm,
  onCancel,
  loading,
  userFullName,
}) => {
  return (
    <Modal
      title="⚠️ Potwierdzenie resetowania weryfikacji"
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Anuluj
        </Button>,
        <Button key="confirm" type="primary" danger loading={loading} onClick={onConfirm}>
          🔄 Reset weryfikacji
        </Button>,
      ]}>
      <div className="space-y-4">
        <div className="bg-orange-50 border border-orange-200 rounded p-3">
          <Text strong className="text-orange-800">
            Czy na pewno chcesz zresetować całą weryfikację dla użytkownika {userFullName}?
          </Text>
        </div>

        <div className="text-sm text-gray-600 space-y-2">
          <div>⚠️ Ta akcja jest nieodwracalna i spowoduje:</div>
          <ul className="list-disc list-inside pl-4 space-y-1">
            <li>Zmianę statusu na INITIAL</li>
            <li>Usunięcie wszystkich danych weryfikacji</li>
            <li>Konieczność rozpoczęcia procesu od nowa przez użytkownika</li>
            <li>Utratę historii aktualnej próby weryfikacji</li>
          </ul>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded p-3">
          <Text className="text-blue-800 text-sm">
            💡 Użytkownik będzie musiał ponownie rozpocząć proces weryfikacji mObywatel od początku.
          </Text>
        </div>
      </div>
    </Modal>
  );
};
